<template>
  <div>
    <user-detail-title
      first-bread="首页管理"
      second-bread="合作伙伴"
      third-bread="合作伙伴查看"
      first-url="/user/quality"
      second-url="/user/partner"
      title-name="合作伙伴查看"
    ></user-detail-title>
    <user-detail-base style="width: 60%">
      <el-form label-position="left" label-width="100px" v-if="LookData">
        <el-form-item label="公司名称" >
          <span>{{LookData.name}}</span>
        </el-form-item>
        <el-form-item label="图片地址">
          <el-image class="item-image" :src="'http://'+LookData.logoAddress" alt=""></el-image>
        </el-form-item>
        <el-form-item label="文字描述">
          <pre>{{LookData.description}}</pre>
        </el-form-item>
        <el-form-item label="创建时间">
          <span>{{LookData.createTime}}</span>
        </el-form-item>
        <el-form-item label="更新时间">
          <span>{{LookData.updateTime}}</span>
        </el-form-item>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  export default {
    name: "PartnerLook",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        LookData:null,
      }
    },
    created() {
      this.GetLookData(this.$route.params.id)
    },
    methods:{
      GetLookData(id){
        this.$axios.get('/api/cooperative/getById',{params:{
            id:id
          }}).then(res=>{
          this.LookData=res.data.data
        })
      }
    }
  }
</script>

<style scoped>

</style>